/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientMedicineNotebookPDFTypename = "PatientMedicineNotebookPDF" as const;

/**
 *
 * @export
 * @interface PatientMedicineNotebookPDF
 */
export interface PatientMedicineNotebookPDF {
  /**
   *
   * @type {Date}
   * @memberof PatientMedicineNotebookPDF
   */
  generatedTime?: string;
  /**
   *
   * @type {string}
   * @memberof PatientMedicineNotebookPDF
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof PatientMedicineNotebookPDF
   */
  path?: string;
  /**
   *
   * @type {string}
   * @memberof PatientMedicineNotebookPDF
   */
  status?: PatientMedicineNotebookPDFStatusEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientMedicineNotebookPDF
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PatientMedicineNotebookPDFStatusEnum {
  Initialized = "initialized",
  Processing = "processing",
  Generated = "generated",
  Failed = "failed",
  Nothing = "nothing",
}

export function PatientMedicineNotebookPDFFromJSON(json: any): PatientMedicineNotebookPDF {
  return PatientMedicineNotebookPDFFromJSONTyped(json, false);
}

export function PatientMedicineNotebookPDFFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatientMedicineNotebookPDF {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientMedicineNotebookPDFTypename,

    generatedTime:
      !exists(json, "generated_time") ||
      (typeof json["generated_time"] === "string" && json["generated_time"].substring(0, 4) === "0001")
        ? undefined
        : json["generated_time"],
    id: !exists(json, "id") ? undefined : json["id"],
    path: !exists(json, "path") ? undefined : json["path"],
    status: !exists(json, "status") ? undefined : json["status"],
  };
}

export function PatientMedicineNotebookPDFToJSON(object?: PatientMedicineNotebookPDF | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    generated_time: value.generatedTime === undefined ? undefined : tzDate(value.generatedTime).format(),
    id: value.id,
    path: value.path,
    status: value.status,
  };
}
